import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeatured = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "-1 -1 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M20.0952 16.071L21.3052 6.94833C21.3235 6.8239 21.3074 6.69681 21.2585 6.5809C21.2097 6.46499 21.13 6.36471 21.028 6.29098C20.9261 6.21724 20.806 6.17288 20.6806 6.16271C20.5552 6.15255 20.4295 6.17698 20.317 6.23333L16.3928 9.22075C16.3189 9.28085 16.2333 9.32496 16.1415 9.3503C16.0497 9.37563 15.9536 9.38164 15.8593 9.36794C15.7651 9.35425 15.6747 9.32114 15.5939 9.27071C15.5131 9.22029 15.4436 9.15365 15.3899 9.075L11.517 3.41C11.4526 3.33612 11.3732 3.27689 11.284 3.23631C11.1948 3.19572 11.098 3.17472 11 3.17472C10.902 3.17472 10.8052 3.19572 10.716 3.23631C10.6268 3.27689 10.5474 3.33612 10.483 3.41L6.61008 9.075C6.55621 9.15351 6.48665 9.21999 6.40577 9.27024C6.3249 9.32049 6.23448 9.35342 6.14024 9.36694C6.04599 9.38047 5.94996 9.3743 5.85822 9.34882C5.76648 9.32334 5.68102 9.27911 5.60725 9.21892L1.683 6.23333C1.57055 6.17698 1.44479 6.15255 1.31941 6.16271C1.19404 6.17288 1.07386 6.21724 0.971952 6.29098C0.870046 6.36471 0.790322 6.46499 0.74146 6.5809C0.692597 6.69681 0.67647 6.8239 0.694833 6.94833L1.90483 16.071H20.0952Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.0625 18.821H19.9375",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	});
};
export default SvgFeatured;
